//********** Print **************//
var Print = new PrintManager();
function PrintManager() {
  this.$preview = false;
  var pageWidth = 560;
  var pageHeight = 1000;
  var agencyPrintHeaderImageUrl =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE8AAABGCAMAAAC65Tl8AAABGlBMVEUAAADWICf///+/v7/WISjtnJ/2ztD87u/98vLXIyrXJCvdR03zvb/0w8X64eL87e387/D+9/f//v7XJSzYKS/YLDPbPUPcP0XcQEbdRkviYmflcnfmeH3uo6bwq67wrrDzvL71ycr2zM720dL309X42Nn53t/65+f76er77Oz87u799vfWIinXJi3XJy7YKjHYLTTZLjXZMDbaNjzcQkjcQ0ndRkzeSlDfT1XgWV7hW2DiX2TiYGXiY2jkb3PlcHTlc3fnfoLogITogYXphorpiIzpiY3qj5PrkJPsl5rvqazwrK/wra/wr7H1ysv2y8320NH31tf42dr429z53d764uP64+T65ub88fH98/P99PT99fX+/Pz//Py1oTTRAAAAAXRSTlMAQObYZgAAAYNJREFUaN7t1ndzgjAUAHASUBQ3dqmtq9ZW7d7b7r33/P5fo3kJClWuItJr/3g5Tl+Sl59cXuCUiCdNajb00EMPPfTQIyS5V6zqb7duvL5se9pUkUILuPCW7mh72i7n6HP3Xv2d2njXoD2Vbrr3YGF7WpyN7hMy6ZUHozMe1tf+V/7CEyv551q+oquFjNLiKVuX0UQimttUzAWLvtIL7eD5xBmhWWPUIIdGjQ71DzQWHH40Zn/wmm3d6oUC5kRskFhTnXrnFk8r86Cq8q+xYGMqHgmXO3j6yXxyO8GCe8v+DUNUSLH79EO0Y3inWud6nEH3mAWvFi/Cgol+iGYrLAyLqbyT+q5CN2WpNzTYPZ/IHGHhuJhKO/Gm+cumxYPgQGQesbAmRhYcnT+7vv39BV175v7Nxcz9I649Xt+rZUJWeH0zvXraAz8favzb+XPvkZBq83z04Nk+v714REnnorXPx4sNhTjw8P8Beuihhx566P2+J8uyJEvs8ur+AAP0P3vs+gJQfSoecw9vqgAAAABJRU5ErkJggg==";
  var agencyPrintHeaderImageUrlPrefix = "data:image/png;base64,";
  var agencyPrintHeaderImageWidth = "79px";
  var agencyPrintHeaderImageHeight = "70px";
  // Default print function.
  // @controls: List of controls to print. If null, prints all view controls.
  this.DefaultPrint = function(
    tabNotLoadedText,
    noDataText,
    printingNotSupportedText,
    targetViewId,
    controls
  ) {
    var self = this;
    var doc = GetViewDocument(targetViewId);
    if (!controls) {
      var formId = "";
      if (doc.forms.length > 0) {
        formId = doc.forms[0].id;
      }
      controls = GetContainedControls(formId);
    }
    var printWindow;
    printWindow = instance.frames["printFrame"];
    printWindow.frameElement.setAttribute(
      "src",
      instance._AppPath + "Print.htm"
    );
    printWindow.frameElement.setupPrint = function() {
      if (self.$preview) {
        printWindow.frameElement.style.position = "absolute";
        printWindow.frameElement.style.height = "200px";
        printWindow.frameElement.style.width = "200px";
        printWindow.frameElement.style.right = "0px";
        printWindow.frameElement.style.top = "100px";
        printWindow.frameElement.style.backgroundColor = "white";
        $(printWindow.document)
          .find("#printCloseBtn")
          .css({ display: "" });
      }
      var printDoc = printWindow.document;
      printDoc.title = doc.title;
      if (
        doc.location.href.toLowerCase().indexOf("crystalreportpage.aspx") >= 0
      ) {
        //TODO:  Update this section
        //
        // If this is the crystal reports viewer, just find the report element and print it.
        var elements = doc.all;
        for (var i = 0; i < elements.length; i++) {
          if (elements[i].isCrystalReport) {
            printDoc.body.insertAdjacentHTML(
              "beforeEnd",
              elements[i].innerHTML
            );
            break;
          }
        }
      } else {
        //
        // Standard page print.
        AddHeader(printDoc, printDoc.body, targetViewId);
        return BuildTable(
          printDoc,
          printDoc.body,
          controls,
          tabNotLoadedText,
          noDataText,
          printingNotSupportedText,
          targetViewId
        );
      }
    };
    printWindow.frameElement.printForm = function() {
      printWindow.focus();
      print();
    };
  };
  this.GetInnerControls = function(containerId) {
    return GetContainedControls(containerId);
  };
  this.BuildTable = function(
    printDoc,
    inner,
    innerControls,
    tabNotLoadedText,
    noDataText,
    printingNotSupportedText,
    targetViewId
  ) {
    return BuildTable(
      printDoc,
      inner,
      innerControls,
      tabNotLoadedText,
      noDataText,
      printingNotSupportedText,
      targetViewId
    );
  };
  // gets a list of printable controls contained in the given container.
  // The list is one level deep; contained controls are not returned.
  // @param container the container to look for controls in
  // @return a list of printable controls in the container.
  function GetContainedControls(containerId) {
    var list = new Array();
    var ids = new Array();
    var i = 0;
    var view = GetView(vid);
    var allControls = view.controlCache;
    var types = [
      "ipsTextbox",
      "ipsDropDownbox",
      "ipsCheckBox",
      "ipsLabel",
      "ipsRichTextEditor",
      "ipsFieldSet",
      "ipsTabset",
      "ipsDataGrid",
      "ipsAttachment",
      "ipsMap",
      "ipsTextTemplate",
      "ipsDashboard"
    ]; //, "ipsGroupArea", "ipsColorGroupArea"];
    for (var j = 0; j < types.length; j++) {
      var controlsPerType = allControls[types[j]];
      for (var c in controlsPerType) {
        var control = allControls[types[j]][c];
        if (control.element.parent().closest(".printContainer").length > 0) {
          if (
            control.element.parent().closest(".printContainer")[0].id ==
            containerId
          ) {
            var id = control.options.id;
            if (ids[control.options.id]) {
              id = id + "_" + i;
            }
            ids[control.options.id] = true;
            list.push({
              controlType: control.getType(),
              clientID: id,
              control: control
            });
            i++;
          }
        }
      }
    }
    list.sort(function(a, b) {
      var dir = 0;
      var pos = a.control.element[0].compareDocumentPosition(
        b.control.element[0]
      );
      if (pos & 2) {
        dir = 1;
      }
      if (pos & 4) {
        dir = -1;
      }
      return dir;
    });
    return list;
  }
  //Print header and agency icon
  function AddHeader(printDoc, printContainer, targetViewId) {
    var headerTable = printDoc.createElement("table");
    headerTable.className = "PrintHeader";
    var tbody = printDoc.createElement("tbody");
    headerTable.appendChild(tbody);
    var tr = printDoc.createElement("tr");
    tbody.appendChild(tr);
    var logoCell = printDoc.createElement("td");
    tr.appendChild(logoCell);
    var logoImage = printDoc.createElement("img");
    logoCell.appendChild(logoImage);
    logoImage.src =
      instance.runTimeOptions.receiptHeaderLogoBase64String != null && instance.runTimeOptions.receiptHeaderLogoBase64String != ""
        ? agencyPrintHeaderImageUrlPrefix + instance.runTimeOptions.receiptHeaderLogoBase64String
        : agencyPrintHeaderImageUrl;
    logoImage.style.width = agencyPrintHeaderImageWidth;
    logoImage.style.height = agencyPrintHeaderImageHeight;
    tr = printDoc.createElement("tr");
    tbody.appendChild(tr);
    var dateCell = printDoc.createElement("td");
    tr.appendChild(dateCell);
    dateCell.innerHTML = FormatLocaleDate(
      new Date(),
      getDateFormat(targetViewId) + " " + getTimeFormat(targetViewId),
      targetViewId
    );
    dateCell.className = "PrintInfoText";
    printContainer.appendChild(headerTable);
    printContainer.appendChild(printDoc.createElement("hr"));
  }
  function BuildTable(
    printDoc,
    printContainer,
    controls,
    tabNotLoadedText,
    noDataText,
    targetViewId
  ) {
    // returns a promise to facilitate async printControl
    var d = $.Deferred();
    var largeControls = [];
    var smallControls = [];
    SortControls(controls, largeControls, smallControls, targetViewId);
    var containsData = !!largeControls.length || !!smallControls.length;
    //Create table for small controls (ie: textbox, dropdown label)
    var table = printDoc.createElement("table");
    table.cellPadding = "0px";
    table.cellSpacing = "0px";
    table.style.width = pageWidth + "px";
    var tbody = printDoc.createElement("tbody");
    table.appendChild(tbody);
    //Add small controls to table  (ie: textbox, dropdown label)
    smallControls.forEach(function(ctrl) {
      try {
        ctrl.control.printControl(printDoc, tbody);
      } catch (e) {
        log(e, "error");
      }
      printContainer.appendChild(table);
    });
    //Add large controls to table (ie: tabset, fieldset)
    $.when
      .apply(
        $,
        largeControls.map(function(ctrl) {
          try {
            return ctrl.control.printControl(
              printDoc,
              printContainer,
              tabNotLoadedText,
              noDataText
            );
          } catch (e) {
            log(e, "error");
          }
        })
      )
      .then(function() {
        var results = Array.prototype.slice.apply(arguments);
        if (
          !containsData ||
          results.some(function(r) {
            return r && r.cancel === true;
          })
        ) {
          d.resolve({ cancel: true, status: "cancelled by control" });
        } else {
          d.resolve(true);
        }
      });
    return d;
  }
  // Utility function to collate and sort a list of controls.
  // @param controls the raw list of controls
  // @param largeControls an empty list which will be populated with a sorted
  // collection of "large" controls from the controls list.
  // @param smallControls an empty list which will be populated with a sorted
  // collection of "small" controls from the controls list.
  function SortControls(controls, largeControls, smallControls, targetViewId) {
    for (var i = 0; i < controls.length; i++) {
      var control = controls[i];
      var type = control.controlType;
      if (
        type == "ipsFieldSet" ||
        type == "ipsTabset" ||
        type == "ipsDataGrid" ||
        type == "ipsMap" ||
        //useBrowserPrint
        type == "ipsAttachment" ||
        type == "ipsDashboard" ||
        false
      ) {
        largeControls[largeControls.length] = control;
      } else {
        smallControls[smallControls.length] = control;
      }
    }
  }
  this.destroy = function destroy() {
    var printWindow = instance.frames["printFrame"];
    if (printWindow) {
      printWindow.frameElement.setupPrint = null;
    }
  };
}
